import axios from 'axios';
import { GRUNTWORX_INTEGRATION_STATUS } from 'constants/constants';

export interface GruntworxConnection {
    id: number;
    is_active: boolean;
    created_by: string;
    updated_by: string;
    created_at: string;
    updated_at: string;
    cpa_id: number;
    status: string;
    gruntworx_key: string;
    created_by_name: string;
}

export const getGruntworxActivationStatus = async (): Promise<boolean> => {
    try {
        const response = await axios.get(GRUNTWORX_INTEGRATION_STATUS);
        return response.data?.success && response.data?.data?.status === 'Active';
    } catch (error) {
        console.error('Failed to get GruntWorx activation status:', error);
        return false;
    }
}; 